import Vue from "vue";
import * as rt from "../../../routes/routes";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router";

export const actions = {
  newDestination({ commit }) {
    let destinationDetail = {
      destination_name: $(".destination_name").val()
    };
    $(".creatingDestination").hide();
    $(".creatingDestinationLoader").show();
    baseurl.post(rt.newDestination, destinationDetail).then(res => {
      $(".creatingDestination").show();
      $(".creatingDestinationLoader").hide();

      if (res.data.code === 200) {
        $('.form-control').val("")
        window.$("#new-destination").modal("hide");
        commit("STORE_DESTINATIONS", res.data.destinations);
        suc.destinationCreateSuccess();
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.DestinationExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingDestination();
      } else if (res.data.code === 405) {
        window.$("#new-destination").modal("hide");
        ers.noPermissionToCreate();
      } else if (res.data.code === 506) {
        window.$("#new-destination").modal("hide");
        ses.sessionComplete();
      }
    });
  },

  loadDestinations({ commit }) {
    baseurl.get(rt.loadDestinations).then(res => {
      $(".destinationsLoader").hide();

      if (res.data.code === 200) {
        commit("STORE_DESTINATIONS", res.data.destinations);
      } else if (res.data.code === 404) {
        ers.errorLoadingDestination();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        commit("STORE_DESTINATIONS", []);
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  destinationUpdate({ commit }) {
    let destinationDetail = {
      id: $(".id").val(),
      destination_name: $(".destination_name").val()
    };
    $(".updatingDestination").hide();
    $(".updatingDestinationLoader").show();
    baseurl.post(rt.destinationUpdate, destinationDetail).then(res => {
      $(".updatingDestination").show();
      $(".updatingDestinationLoader").hide();

      if (res.data.code === 200) {
        window.$("#update-destination").modal("hide");
        commit("STORE_DESTINATIONS", res.data.destinations);
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 404) {
        ers.errorUpdatingDestination();
      } else if (res.data.code === 405) {
        window.$("#update-destination").modal("hide");
        ers.noPermissionToUpdate();
      } else if (res.data.code === 506) {
        window.$("#update-destination").modal("hide");
        ses.sessionComplete();
      }
    });
  }
};
export default actions;


// WEBPACK FOOTER //
// ./src/vuex/modules/destinations/actions.js